import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 203 326",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M35 204.949C35 241.047 63.301 264.728 101.421 264.728C139.54 264.728 167.841 241.047 167.841 204.949C167.841 183.001 156.868 167.407 144.45 159.032V158.454C153.691 151.812 163.51 137.662 163.51 119.18C163.51 88.8571 141.273 62 101.421 62C61.5683 62 39.3318 88.8571 39.3318 119.18C39.3318 137.662 49.1505 151.812 58.3916 158.454V159.032C45.9739 167.407 35 183.001 35 204.949ZM101.421 141.994C87.8478 141.994 78.8954 131.597 78.8954 119.18C78.8954 106.473 87.8478 96.0767 101.421 96.0767C114.994 96.0767 123.946 106.473 123.946 119.18C123.946 131.597 114.994 141.994 101.421 141.994ZM74.8524 203.216C74.8524 187.333 85.5375 176.07 101.421 176.07C117.304 176.07 127.989 187.333 127.989 203.216C127.989 219.388 117.304 230.651 101.421 230.651C85.5375 230.651 74.8524 219.388 74.8524 203.216Z",
      fill: "#E5E5E5"
    }, null, -1)
  ])))
}
export default { render: render }